var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","content-class":"modern-tooltip","max-width":300,"transition":"fade-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"tooltip-icon ml-2",attrs:{"color":"primary","small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-information-outline ")])]}}])},[_c('span',{staticClass:"tooltip-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }